import { AccountEntityType } from "@/lib/constants/account-types";

export const getLedgerStatusStyle = (entityType?: AccountEntityType | null) => {
  switch (entityType) {
    case AccountEntityType.COUNTERPARTY:
      return "bg-green-100 border-green-200 text-green-800 hover:bg-green-100";
    case AccountEntityType.EXPENSE_ACCOUNT:
      return "bg-gray-100 border-gray-200 text-gray-800 hover:bg-gray-100";
    case AccountEntityType.BANK_ACCOUNT:
      return "bg-blue-100 border-blue-200 text-blue-800 hover:bg-blue-100";
    default:
      return "bg-secondary text-secondary-foreground hover:bg-secondary";
  }
};
